import React from 'react'
import { useI18n } from '../../i18n'
import wfStyles from '@/styles/pages/compliance-workflow/ComplianceWorkflow.module.scss'

export type WorkflowSection = 'scope' | 'applicability' | 'readiness' | 'certification' | 'topology'

interface Props {
  active: WorkflowSection
  onSelect: (section: WorkflowSection) => void
  workflowStage?: string
}

const SECTIONS: { id: WorkflowSection; labelKey: string; fallback: string }[] = [
  { id: 'scope', labelKey: 'complianceWorkflow.scopeBuilder', fallback: 'Scope Builder' },
  { id: 'applicability', labelKey: 'complianceWorkflow.applicabilityDiscovery', fallback: 'Applicability Discovery' },
  { id: 'readiness', labelKey: 'complianceWorkflow.readinessBaseline', fallback: 'Readiness Baseline' },
  { id: 'certification', labelKey: 'complianceWorkflow.certificationWorkspace', fallback: 'Certification Workspace' },
  { id: 'topology', labelKey: 'complianceWorkflow.scopeVisualization', fallback: 'Scope Visualization' },
]

export default function ComplianceWorkflowSidebar({ active, onSelect, workflowStage }: Props) {
  const { t } = useI18n()
  return (
    <aside className={wfStyles.sidebar}>
      <p className={wfStyles.sidebarStage}>{workflowStage || '—'}</p>
      <ul className={wfStyles.navList}>
        {SECTIONS.map((s) => (
          <li key={s.id}>
            <button
              type="button"
              onClick={() => onSelect(s.id)}
              className={`${wfStyles.navItem} ${active === s.id ? wfStyles.navItemActive : ''}`}
            >
              {t(s.labelKey, s.fallback)}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  )
}
